/* eslint-disable */

const pageVotreEspaceMembre = document.querySelector('body.template-votre-espace-membre');

if (pageVotreEspaceMembre) {
  console.log('hello from pagination');
  let currentIndex = 1;
  const minPage = 1;
  const maxPage = 3;
  const maxItemsPerPages = 15;
  const paginationWrapper = document.querySelector('.pagination');
  const baseItems = document.querySelectorAll('table tbody > tr');


  initializePagination();

  filterTableRow();

  function filterTableRow() {
    const items = document.querySelectorAll('table tbody > tr.show');

    const filters = document.querySelectorAll('#filtre-membre > li');

    filters.forEach(filter => {
      filter.addEventListener('click', function () {
        document.querySelector('#filtre-membre >li.is_active').classList.remove('is_active');
        filter.classList.add('is_active');

        // Show all tr
        if (filter.classList.contains('all')) {
          baseItems.forEach(item => item.classList.add('show'))
          currentIndex = 1;
          resetPagination();
          initializePagination();
        }

        const filterableItems = document.querySelectorAll(`table tbody > tr[data-cat=${filter.dataset.cat}]`);
        if (filterableItems.length > 0) {
          // remove class of previous filtered items
          const prevItems = document.querySelectorAll('table tbody > tr.show')
          prevItems.forEach(prevItem => prevItem.classList.remove('show'))
          // add show class to newly filtered items
          filterableItems.forEach(item => item.classList.add('show'))

          currentIndex = 1;
          resetPagination();
          initializePagination();

          // add active class used in the pagination to keep table rows displayed
          for (let i = 0; i < maxItemsPerPages; i++) {
            filterableItems[i].classList.add('active')
          }
        }
      })
    })
  }


  function initializePagination() {

    const items = document.querySelectorAll('table tbody > tr.show');
    const numberOfPages = Math.ceil(items.length / maxItemsPerPages);
    addButton('Précédent', currentIndex - 1, numberOfPages);
    if (currentIndex - 1 > minPage) {
      addButton('...', 1, numberOfPages);
    }
    let pagination = currentIndex;
    if (currentIndex > 1) {
      pagination = currentIndex - 1;
    }
    let i = 0;
    for (let index = pagination; index <= numberOfPages; index++) {
      if (i < maxPage) {
        let button = addButton(index, index, numberOfPages);
        console.log('index', index, 'currentIndex', currentIndex)
        if (index === currentIndex) {
          button.classList.add('active');
        }
        i = i + 1;
      }
    }

    console.log('currentIndex', currentIndex, 'numPages', numberOfPages)
    if (currentIndex + 1 < numberOfPages && (numberOfPages !== maxPage)) {
      addButton('...', numberOfPages, numberOfPages);
    }
    addButton('Suivant', currentIndex + 1, numberOfPages);
    console.log('INDEX', currentIndex)
    for (let i = (currentIndex * maxItemsPerPages) - maxItemsPerPages; i < currentIndex * maxItemsPerPages; i++) {
      if (items[i] && items[i]) {
        items[i].classList.add('active');
      }
    }
  }

  function setPaginationTo(index, numberOfPages) {
    if ((index >= minPage && index <= numberOfPages) && index !== currentIndex) {
      currentIndex = parseInt(index);
    }
  }

  function addButton(text, index, numberOfPages) {
    let button = document.createElement('li');
    button.setAttribute('class', 'page-item');
    button.setAttribute('data-controls', index);
    let link = document.createElement('a');
    link.setAttribute('class', 'page-link');
    link.textContent = text;
    paginationWrapper.append(button);
    button.append(link);
    button.addEventListener('click', function () {
      resetPagination();
      setPaginationTo(button.getAttribute('data-controls'), numberOfPages);
      initializePagination();
    });
    return button;
  }

  function resetPagination() {
    baseItems.forEach(function (item) {
      if (item.classList.contains('active')) {
        item.classList.remove('active');
      }
    });
    paginationWrapper.innerHTML = '';
  }
}





// WEBPACK FOOTER //
// ./scripts/espaceMembre.js